import React from 'react';
import { Card, Col, Button, Progress, CardText } from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;


const MissionsCardHome = (props) => {

    const { slug, image, buttonText, stats, name } = props.mission;

    const number = stats.percentage_reached;
    const completed_percentage = (Math.floor(number, -2));
    return (
			<Col lg="4" md="6" sm="12" xs="12" className="mission-card-homepage">
				<a
					href={`/missions/${slug}`}
					onClick={() => {
						const eventInfo = {
							missionName: name
						};
						if (window.eventDispatcher) {
							window.eventDispatcher.dispatchEventSync(
								'missions-card',
								eventInfo,
								{ amplitude: true }
							);
						}
						return true;
					}}
					style={{ textDecoration: 'none' }}
				>
					<Card className="missions-card mcm-tile">
						<div style={{ position: 'relative' }}>
							<img
								style={{ width: '100%' }}
								src={`${config.cdnUrl}${image.imgUrlPath}${image.imgUrl}`}
								alt={image.imgAlt}
								loading="lazy"
							/>
						</div>
						<CardText className="missions-card-text-box ">
							<div className="">
								<p className="supporting-card-bold-text first-element-name ">
									{name}
								</p>
							</div>
							<div className="progress-wrapper">
								{/* <div className="" style={{ paddingBottom: '10px' }}>
                            <span className="">{stats.target} {props.mission.targetText}</span>
                        </div> */}
								<Progress
									className="supporter-process-bar"
									value={stats.percentage_reached}
								/>
								<div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
									<p style={{ color: '#444444' }}>
										<span>
											<span className=" monthly-count-supporters">
												{stats.monthly_supporters}
											</span>{' '}
											monthly supporters
										</span>
										<span className=" completed-supporters">
											{completed_percentage}%{' '}
										</span>
									</p>
								</div>
							</div>
							<a
								href={`/missions/${slug}`}
								onClick={() => {
									const eventInfo = {
										missionName: name
									};
									if (window.eventDispatcher) {
										window.eventDispatcher.dispatchEventSync(
											'missions-card-btn',
											eventInfo,
											{ amplitude: true }
										);
									}
								}}
							>
								<Button
									color="primary"
									className="btn-full-width btn  btn-primary"
								>
									{buttonText}
								</Button>
							</a>
						</CardText>
					</Card>
				</a>
				<style jsx global>
					{`
						.first-element-name::first-word {
							color: #000000 !important;
						}
						@media (max-width: 1023px) {
							.mission-card-homepage {
								margin-bottom: 1rem;
							}
						}
						@media (max-width: 767px) {
							.mission-card-homepage {
								margin-bottom: 1rem;
								padding: 0;
							}
							.mcm-tile {
								margin-bottom: 0 !important;
							}
						}

						.missions-card.card {
							box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
						}

						.missions-card-text-box {
							padding: 1rem;
						}
						@media (max-width: 768px) {
							.missions-card-text-box {
								padding: 1rem;
							}
							.missions-card.card {
								box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
							}
							.missions-card-for-mobile {
								padding: 0px;
							}
						}
						.card-price {
							margin-bottom: 10px;
						}
						.card-price h6 {
							margin-bottom: 0;
							font-weight: 600;
						}
						.tag-row {
							margin-bottom: 10px;
						}
						.giveassured-position {
							position: absolute;
							bottom: 3px;
							right: 3px;
							background: white;
							padding: 1px 5px;
							border-radius: 5px;
							box-shadow: 0 2px 2px rgba(50, 50, 93, 0),
								0 1px 2px rgba(0, 0, 0, 0.08);
						}
						.supporting-card-bold-text {
							font-weight: 600;
							font-size: 18px;
							color: #ff5050 !important;
						}
						.supporter-process-bar.progress {
							height: 8px !important;
						}
						.supporter-process-bar .progress-bar {
							background: #ff5050 !important;
						}
						.completed-supporters {
							float: right;
							color: #666666 !important;
						}
						.monthly-count-supporters {
							color: #666666 !important;
						}
					`}
				</style>
			</Col>
		);
};


export default MissionsCardHome;

